import { Affix } from 'antd'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { cycleSort, SortOrder } from '../utils'
import columns from './HostsListColumns'
import HostsListHeader from './HostsListHeader'
import HostsListItem from './HostsListItem'
import HostsListHeaderMobile from './HostsListHeaderMobile'
import HostsListItemMobile from './HostsListItemMobile'
import Breakpoint from './Breakpoint'

// insert if
const a = []
const ii = (condition, ...elements) => (condition ? elements : a)

const OL = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
`

export default class HostsList extends Component {
  static columns = columns

  constructor(props, context) {
    super(props, context)

    this.state = {
      hosts: this.props.hosts.filter(h => h.enabled !== false),
      sortBy: 'ratings',
      sortOrder: SortOrder.DESC,
      hasMounted: false,
      affixed: false,
    }
  }

  componentDidMount = () => {
    this.setState({ hasMounted: true })
  }

  static getDerivedStateFromProps(props, state) {
    if (props.hosts !== state.hosts) {
      const hosts = props.hosts.sort(
        HostsList.columns.find(c => c.columnKey === state.sortBy).sorter
      )

      if (state.sortOrder === SortOrder.DESC) {
        hosts.reverse()
      }

      return {
        hosts,
      }
    }

    // Return null to indicate no change to state.
    return null
  }

  _onSortChange = ({ columnKey, sorter }, sortOrder = false) => {
    let hosts = this.props.hosts

    sortOrder =
      sortOrder ||
      cycleSort(this.state.sortBy === columnKey && this.state.sortOrder)

    hosts = this.props.hosts.sort(sorter)

    if (sortOrder === SortOrder.DESC) {
      hosts.reverse()
    }

    this.setState({
      sortBy: sortOrder && columnKey,
      sortOrder,
      hosts,
    })
  }

  render() {
    const {
      hosts,
      listHeader = HostsListHeader,
      listItem = HostsListItem,
      affixHeader = true,
      breakpoint = 992,
      ...props
    } = this.props

    return (
      <OL {...props} key={this.state.hasMounted ? 'mounted' : 'unmounted'}>
        <Breakpoint
          width={breakpoint}
          render={broke => {
            const ListHeader = broke ? HostsListHeaderMobile : HostsListHeader
            const ListItem = broke ? HostsListItemMobile : HostsListItem
            const listItems = this.state.hosts.map(host => (
              <li key={host.id}>
                <ListItem host={host} columns={HostsList.columns} />
              </li>
            ))

            const listHeaderElem = (
              <ListHeader
                affixed={this.state.affixed}
                sortBy={this.state.sortBy}
                sortOrder={this.state.sortOrder}
                onSortChange={this._onSortChange}
                columns={HostsList.columns}
              />
            )

            return (
              <Fragment>
                {affixHeader ? (
                  <Affix onChange={affixed => this.setState({ affixed })}>
                    {listHeaderElem}
                  </Affix>
                ) : (
                  listHeaderElem
                )}
                {listItems}
              </Fragment>
            )
          }}
        />
      </OL>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsList.jsx